import React from 'react';
import { useTheme } from '../context/ThemeContext';

export default function ThemeBar() {
  const { themeId, themes, setTheme } = useTheme();

  return (
    <div className="theme-bar" role="toolbar" aria-label="Portal color themes">
      <span className="theme-bar-label">Theme</span>
      <div className="theme-bar-swatches">
        {themes.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`theme-swatch${themeId === t.id ? ' is-active' : ''}${t.lightSwatch ? ' theme-swatch--light' : ''}`}
            style={{ '--swatch': t.swatch }}
            aria-label={t.label}
            aria-pressed={themeId === t.id}
            title={t.label}
            onClick={() => setTheme(t.id)}
          />
        ))}
      </div>
    </div>
  );
}
